<template>
    <div class="attachment-group" v-if="this.attachments.length > 0 || this.groupedAttachments.length > 0">
        <button class="flex justify-between items-center mb-6 w-full" @click="accordionOpen = !accordionOpen" v-if="hasAccordion">
            <h2 class="font-walsheim text-lg">{{ title }}</h2>
            <ChevronDown class="transition-transform delay-50 ease-in-out" :class="{
                '-rotate-90': !accordionOpen
            }"/>
        </button>
        <div class="flex flex-row justify-between mb-6" v-else>
            <h2 class="font-walsheim text-lg">{{  title }}</h2>
        </div>
        <div class="relative overflow-hidden">
            <Transition name="accordion" v-if="hasAccordion">
                <div class="grid gap-6 relative" v-if="accordionOpen">
                    <!-- <AttachmentItem v-for="attachment in attachments" :key="attachment.id"/> -->
                    <AttachmentItem :attachment-type="attachmentType" v-for="attachment in attachments" :attachment="attachment" :key="attachment.id"/>
                    <AttachmentItemGroup :attachment-type="attachmentType" v-for="attachments in groupedAttachments" :key="attachments[0].id" :attachments="attachments"/>
                </div>
            </Transition>
            <div class="grid gap-6 relative" non-accordion v-else>
                <AttachmentItem :attachment-type="attachmentType" v-for="attachment in attachments" :attachment="attachment" :key="attachment.id"/>
                <AttachmentItemGroup :attachment-type="attachmentType" v-for="attachments in groupedAttachments" :key="attachments[0].id" :attachments="attachments"/>
            </div>
        </div>
    </div>
</template>

<script>
import AttachmentItem from '@/BuyNow/Components/AttachmentItem.vue';
import AttachmentItemGroup from '@/BuyNow/Components/AttachmentItemGroup.vue';
import ChevronDown from '@/../svg/chevron-down.svg?component';

export default {
    data() {
        return {
            accordionOpen: true
        };
    },
    components: {
        AttachmentItem,
        AttachmentItemGroup,
        ChevronDown,
    },
    mounted() {
    },
    props: {
        title: String,
        hasAccordion: {
            type: Boolean,
            default: false,
        },
        attachmentType: String
    },
    methods: {
    },
    created() {
    },
    computed: {
        selectedCountry() {
            return this.$store.state.userInfo.country;
        },
        selectedCurrency() {
            return this.$store.state.userInfo.currency;
        },
        attachments() {
            return this.$store.getters.selectedPlan[this.attachmentType + 's'].filter((item) => {
                if (!!item.metadata.showForCountries) {
                    if (!item.metadata.showForCountries.includes(this.selectedCountry.toUpperCase()) || this.selectedCurrency != 'USD') {
                        return false;
                    }
                }
                return item.metadata.showInCart && !item.metadata.group;
            }).sort((a, b) => {
                return a.metadata.order - b.metadata.order;
            });
        },
        groupedAttachments() {
            let attachments = this.$store.getters.selectedPlan[this.attachmentType + 's'].filter((item) => {
                if (!!item.metadata.showForCountries) {
                    if (!item.metadata.showForCountries.includes(this.selectedCountry.toUpperCase()) || this.selectedCurrency != 'USD') {
                        return false;
                    }
                }
                return item.metadata.showInCart && item.metadata.group;
            }).sort((a, b) => {
                return a.metadata.order - b.metadata.order;
            });
            let groupedItems = [];
            attachments.forEach((item) => {
                const groupKey = item[item.metadata.group.name];

                const groupIndex = groupedItems.findIndex(group => group[0][item.metadata.group.name] === groupKey);
                if (groupIndex !== -1) {
                    groupedItems[groupIndex].push(item);
                } else {
                    groupedItems.push([item]);
                }
            });
            return groupedItems;
        }
    },
    watch: {
    }
};
</script>

<style lang="postcss" scoped>
.accordion-enter-active,
.accordion-leave-active {
    @apply transition-all duration-200 ease-in-out;
}

.accordion-enter-from,
.accordion-leave-to {
    @apply -mt-[100%];
}
</style>
